import { SVGProps } from 'react';

const Customize = ({
	width = 21,
	height = 21,
	fill,
	...otherProps
}: SVGProps<SVGElement>) => (

	<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M0 7C0 5.89543 0.895431 5 2 5H8V7H3C2.44772 7 2 7.44771 2 8V18C2 18.5523 2.44772 19 3 19H13C13.5523 19 14 18.5523 14 18V13H16V19C16 20.1046 15.1046 21 14 21H2C0.895431 21 0 20.1046 0 19V7Z" fill="url(#paint0_angular_9886_1619)"/>
		<path fillRule="evenodd" clipRule="evenodd" d="M17.6208 0.18165C17.7645 0.0370364 17.9705 -0.0270439 18.1709 0.010574C18.2919 0.0324569 18.4035 0.0900864 18.4914 0.176055L20.8151 2.49717C20.9317 2.61303 20.997 2.77081 20.9966 2.93516C20.9962 3.09953 20.93 3.25687 20.8128 3.37216L10.9534 13.2294C10.8667 13.3154 10.7564 13.3737 10.6365 13.3968L7.74012 13.9806C7.5376 14.0227 7.32733 13.9599 7.18086 13.8138C7.03424 13.6676 6.97101 13.4577 7.0125 13.2548L7.59754 10.3533C7.62014 10.2347 7.67707 10.1253 7.76133 10.0389L17.6208 0.18165ZM19.5099 2.93688L18.0606 1.48702L17.3718 2.17577L18.8215 3.62545L19.5099 2.93688ZM17.9732 4.47413L16.5233 3.0243L8.76285 10.7849L8.40439 12.5929L10.2198 12.2302L17.9732 4.47413Z" fill="#2A2A2A"/>
		<defs>
			<radialGradient id="paint0_angular_9886_1619" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.4983 10.5) rotate(-48.8187) scale(13.9511 13.9508)">
				<stop stopColor="#335AFF"/>
				<stop offset="0.338542" stopColor="#FF4F28"/>
				<stop offset="0.65625" stopColor="#FFD600"/>
				<stop offset="1" stopColor="#00BE82"/>
			</radialGradient>
		</defs>
	</svg>

);

export default Customize;